<now-wbsuche-lib-main-layout [ngClass]="{ 'now-keyboard-mode': keyboardMode }">
  <div role="presentation">
    <router-outlet></router-outlet>
    <now-wbsuche-app-back-to-top-button></now-wbsuche-app-back-to-top-button>
  </div>
  <now-wbsuche-app-oiam-oauth></now-wbsuche-app-oiam-oauth>
  <!-- Die Einbindung der nowsuche-lib passiert aktuell ueber den Router und router-outlet -->
  <now-wbsuche-app-version></now-wbsuche-app-version>
  <now-wbsuche-lib-modal-popup
    #errorModal
    modalId="errorModal"
    modalTitle="Es ist ein Fehler aufgetreten"
    primaryButtonText="Abbrechen"
    secondaryButtonText=""
    >Es konnten aufgrund von technischen Problemen keine Daten geladen werden.
  </now-wbsuche-lib-modal-popup>
</now-wbsuche-lib-main-layout>
